import { fitSize } from '../../../utils/fuelReadings';

// reduz a foto no próprio celular antes de enviar (4 mb viram ~300 kb):
// economiza o 4g e o disco do servidor. se o navegador não conseguir,
// manda a original.
export async function compressPhoto(file: File): Promise<Blob> {
  try {
    const url = URL.createObjectURL(file);
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const element = new Image();

      element.onload = () => resolve(element);
      element.onerror = reject;
      element.src = url;
    });
    const size = fitSize(image.naturalWidth, image.naturalHeight);
    const canvas = document.createElement('canvas');

    canvas.width = size.width;
    canvas.height = size.height;
    canvas.getContext('2d')?.drawImage(image, 0, 0, size.width, size.height);
    URL.revokeObjectURL(url);

    const blob = await new Promise<Blob | null>(resolve =>
      canvas.toBlob(resolve, 'image/jpeg', 0.82),
    );

    return blob && blob.size > 0 ? blob : file;
  } catch {
    return file;
  }
}
